// extracted by mini-css-extract-plugin
module.exports = {"tabList":"ProgrammeDiscrepancyCheck_tabList__EIaTk","placeholderWrapper":"ProgrammeDiscrepancyCheck_placeholderWrapper__3xNYQ"};